import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgHeartFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#heart-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: 28,
        cy: 28,
        r: 28,
        fill: "#E4EFFA",
        transform: "rotate(-180 28 28)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M10.57 17.893C5.89 26.153 11.71 35.636 27.5 46c15.79-10.364 21.61-19.848 16.93-28.107-3.487-6.152-12.538-6.346-16.93-1.463-4.392-4.883-13.443-4.689-16.93 1.463"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        fillRule: "evenodd",
        d: "M42.807 16.521c-3.912-4.797-11.697-4.58-15.645-.035-4.311-4.963-13.197-4.766-16.62 1.488-1.256 2.294-1.742 4.681-1.468 7.154 2.855 4.646 8.07 9.541 15.582 14.647 12.323-8.376 18.461-16.185 18.15-23.254",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `heart-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgHeartFidelityLow;
